import type {
  insuranceCoverageApiSpec,
  planEnrollmentApiSpec
} from "@wingspanhq/wingspan-api-types";
import { getOAIBenefitListItem } from "../../Benefits/components/customBenefits/OAI/getOAIBenefitListItem";

type IPolicyType = insuranceCoverageApiSpec.InsuranceCoverage["policyType"];
type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const selectorPolicyNameByPolicyType = (
  policyType: IPolicyType,
  planType: IPlanType
): string => {
  const names: Partial<Record<IPolicyType, string>> = {
    OccupationalAccident: getOAIBenefitListItem().name,
    GeneralLiability:
      "Wingspan Professional & General Liability Insurance (GL)",
    ProfessionalLiability:
      "Wingspan Professional & General Liability Insurance (PL)"
  };

  return names[policyType] || "Insurance coverage";
};
